
export default function MapTitle({title}){
  return <p className="title-place">{title}</p>;
}